// Remove from cart tracking
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const removeLink = e.target.closest('a[href*="/cart/change"][href*="quantity=0"]');
    if (removeLink) {
      const href = removeLink.getAttribute('href');
      const variantIdMatch = href.match(/id=([^:&]+)/);
      const variantId = variantIdMatch ? variantIdMatch[1] : 'unknown';
      const ariaLabel = removeLink.getAttribute('aria-label');
      const productName = ariaLabel ? ariaLabel.replace('Remove ', '') : 'Unknown Product';
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cartItem = cart.items.find((item) => item.variant_id == variantId);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
              items: [{
                item_name: cartItem ? cartItem.product_title : productName,
                item_id: variantId,
                price: cartItem ? (cartItem.price / 100).toFixed(2) : '0.00',
                currency: cart.currency,
                item_brand: cartItem ? cartItem.vendor : 'Unknown',
                item_category: cartItem ? cartItem.product_type : 'Unknown',
                quantity: cartItem ? cartItem.quantity : 1,
              }],
            },
          });
        });
    }
  });
});

// Shipping info tracking
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/checkout') || window.location.pathname.includes('/cart')) {
    document.addEventListener('change', function (e) {
      if (e.target.type === 'radio' && (e.target.name === 'checkout[shipping_rate][id]' || e.target.name.includes('shipping'))) {
        const shippingMethod = e.target.closest('label')?.textContent?.trim() || 'Standard';
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const items = cart.items.map((item) => ({
              item_name: item.product_title,
              item_id: item.variant_id,
              price: (item.price / 100).toFixed(2),
              currency: cart.currency,
              item_brand: item.vendor || 'Unknown',
              item_category: item.product_type || 'Unknown',
              quantity: item.quantity,
            }));
            window.dataLayer.push({
              event: 'add_shipping_info',
              ecommerce: { shipping_tier: shippingMethod, items: items },
            });
          });
      }
    });
  }
});

// Express payment tracking
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[data-shopify-buttonpay]') ||
      e.target.closest('.shopify-payment-button') ||
      e.target.textContent.toLowerCase().includes('shop pay')
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'express_shoppay' });
    }
    if (
      e.target.closest('[data-google-pay]') ||
      e.target.closest('.google-pay-button') ||
      e.target.textContent.toLowerCase().includes('google pay') ||
      e.target.textContent.toLowerCase().includes('g pay')
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'express_gpay' });
    }
  });
});

// Newsletter subscription tracking
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (
      form.querySelector('input[type="email"]') &&
      (form.action.includes('customer') ||
        form.querySelector('[name*="email"]') ||
        form.classList.contains('newsletter') ||
        form.id.includes('newsletter'))
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'submit_subscription_form' });
    }
  });
});

// Mini-cart gift section visibility
function applyGiftVisibility() {
  const giftSection = document.querySelector('.mini-cart__gift-section');
  if (!giftSection) return;
  if (localStorage.getItem('giftHidden') === 'true') {
    giftSection.style.display = 'none';
  } else {
    giftSection.style.display = '';
  }
}

function observeMiniCart() {
  const miniCart = document.querySelector('mini-cart');
  if (!miniCart) return;
  const observer = new MutationObserver(applyGiftVisibility);
  observer.observe(miniCart, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', function () {
  observeMiniCart();
  applyGiftVisibility();
});

document.body.addEventListener('cart:updated', applyGiftVisibility);

window.toggleGiftSection = function (hide) {
  localStorage.setItem('giftHidden', hide ? 'true' : 'false');
  applyGiftVisibility();
};

// Cart count in header
(function () {
  function updateCartCount() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const cartTrigger = document.getElementById('desktop-cart-trigger');
        if (cartTrigger) {
          const label = cartTrigger.dataset.cartLabel || 'CART';
          cartTrigger.innerHTML = `${label} (${cart.item_count})`;
        }
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', updateCartCount);

  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      try {
        const url = response.url;
        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        ) {
          updateCartCount();
        }
      } catch (e) {}
      return response;
    });
  };
})();
